export default __webpack_public_path__ + "static/rodriguez-9661256bb724bb8f567444e89cfea7b8.jpg";